import { render, staticRenderFns } from "./renewalWarning.vue?vue&type=template&id=3d63ae63&scoped=true"
import script from "./renewalWarning.vue?vue&type=script&lang=js"
export * from "./renewalWarning.vue?vue&type=script&lang=js"
import style0 from "./renewalWarning.vue?vue&type=style&index=0&id=3d63ae63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d63ae63",
  null
  
)

export default component.exports